
import './App.css';
import Home from './components/Home';
import './css/Modern.css';

function App() {
  return (
    <div className="App">
        <Home />
    </div>
    
  );
}

export default App;
